import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';

import Box from 'components/box';
import {Label, Select, SelectWithSearchAsync, Divider, SearchFail, UniversalSelectWrapper,
  UniversalSearchWrapper, UniversalDateWrapper, UniversalDateTime} from 'components/common';
import {AccostsList} from './accosts-list';
import Pagination from 'pagination';
import Spinner from 'spinner';
import {PageHead} from 'components/header/components';
import {ButtonDefault} from 'components/buttons';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import {searchAccosts, loadMedicalInstitutions, searchAccostsByInstitution, loadInstitutionParentPersonal, currentUserInstitutionsIsLoading} from 'redux/actions/portal/institutions';


const mapStateToProps = state => ({
  user: state.auth.get('user'),
  accosts: state.institutions.get('accostList'),
  institutions: state.institutions.get('institutionsList'),
  staff: state.institutions.get('institutionPersonal'),
  staffDetail: state.institutions.get('currentUserInstitutions'),
  currentUserInstitutionsIsLoading: state.institutions.get('currentUserInstitutionsIsLoading'),
  isLoading: state.institutions.get('institutionsIsLoading'),
});


const mapDispatchToProps = (dispatch) => ({
  loadInstitutions: (id, search) => dispatch(loadMedicalInstitutions(id, search)),
  loadInstitutionPersonal: (id, search) => dispatch(loadInstitutionParentPersonal(id, search)),
  searchAccosts: (staff_id, administration, institution, start_date, end_date, type, status, offset) => {
    dispatch(searchAccosts("False", staff_id, administration, institution, start_date, end_date, type, status, 10, offset))
  },
  searchAccostsByInstitution: (staff_id, institution, start_date, end_date, type, status, limit, offset) => {
    dispatch(searchAccostsByInstitution("False", staff_id, institution, start_date, end_date, type, status, 10, offset))
  },
});

class AdministrationReviews extends Component {

  state = {
    start_date: moment("01-01-2018", "MM-DD-YYYY"),
    end_date: moment().add(3, 'month'),
    type: '',
    status: '',
    staff_id: '',
    institution: "",
    personalSelect: '',
    institutionSelect: ''
  }

  selectStyle = {
    border: 'none'
  }

  clickOutside = () => {
    this.refs.pickerStart.cancelFocusInput();
    this.refs.pickerStart.setOpen(false);
    this.refs.pickerEnd.cancelFocusInput();
    this.refs.pickerEnd.setOpen(false);
  }

  changeType = event => this.setState({ type: event.target.value })

  changeStatus = event => this.setState({ status: event.target.value })

  onChangeStartDate = date => this.setState({ start_date: date })

  onChangeEndDate = date => this.setState({ end_date: date })

  onChangeInstitutions = institution => {
    let institutionValue = institution ? institution.value : ''
    this.setState({
      institutionSelect: institution,
      institution: institutionValue
    });
  }

  generateInstitutionOptions = results => {
    return results.reduce((arr, item) => {
      const newOption = {value: item.get('id'), type: item.get('institution_type'), label: item.get('full_title') };
      arr.push(newOption);
      return arr
    }, [])
  }

  loadInstitutions = search => {
    const institutionId = this.props.user.get('is_superuser') ? '' : this.props.staffDetail.getIn(['results', 0, 'institution']);
    if (!search) search=''
    return this.props.loadInstitutions(institutionId, search)
      .then(response => {
        const results = response.get('results');
        if(!results.size) return Promise.resolve({ options: [] });
        const options = this.generateInstitutionOptions(results);
        return { options }
      })
  }

  onChangePersonal = personal => {
    let personalValue = personal ? personal.value : ''
    this.setState({
      personalSelect: personal,
      staff_id: personalValue
    });
  }

  generatePersonalOptions = results => {
    return results.reduce((arr, item) => {
      const newOption =  {
        value: item.getIn(['id']),
        label: `${item.getIn(['user_data', 'last_name'])} ${item.getIn(['user_data', 'first_name'])} ${item.getIn(['user_data', 'middle_name'])} 
        (${item.getIn(['doctor_data', 'profession_classification_data', 'profession_title'])})`
      }
      arr.push(newOption)
      return arr
    }, [])
  }

  loadPersonal = search => {
    const institutionId = this.props.user.get('is_superuser') ? '' : this.props.staffDetail.getIn(['results', 0, 'institution']);
    if (!search) search=''
    return this.props.loadInstitutionPersonal(institutionId, search)
      .then(results => {
        if(!results.size) return Promise.resolve({ options: [] })
        const options = this.generatePersonalOptions(results)
        return { options }
      })
  }

  onSubmitForm = event => {
    event.preventDefault();
    const page = this.props.match.params.page || 1;
    const offset = 10 * (page - 1);
    if (this.props.user.get('is_superuser')) {
      page != 1
        ? this.props.history.push(`/administration/staff-reviews/1`)
        : this.props.searchAccostsByInstitution(this.state.staff_id, this.state.institution, this.state.start_date, this.state.end_date, this.state.type, this.state.status, offset)
    } else {
      page != 1
        ? this.props.history.push(`/administration/staff-reviews/1`)
        : this.props.searchAccosts(this.state.staff_id, this.props.staffDetail.getIn(['results', 0, 'institution']), this.state.institution, this.state.start_date, this.state.end_date, this.state.type, this.state.status, offset)
    }
  }

  componentDidMount() {
    const page = this.props.match.params.page || 1;
    const offset = 10 * (page - 1);
    if (this.props.user.get('is_superuser')) {
      this.props.searchAccosts(this.state.staff_id, '', this.state.institution, this.state.start_date, this.state.end_date, this.state.type, this.state.status, offset);
    } else {
      if (this.props.staffDetail.get('results').size > 0) {
        this.props.searchAccosts(this.state.staff_id, this.props.staffDetail.getIn(['results', 0, 'institution']), this.state.institution, this.state.start_date, this.state.end_date, this.state.type, this.state.status, offset);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.page !== nextProps.match.params.page) {
      const page = nextProps.match.params.page || 1;
      const offset = 10 * (page - 1);
      if (this.props.user.get('is_superuser')) {
        this.props.searchAccosts(this.state.staff_id, '', this.state.institution, this.state.start_date, this.state.end_date, this.state.type, this.state.status, offset)
      } else {
        this.props.searchAccosts(this.state.staff_id, this.props.staffDetail.getIn(['results', 0, 'institution']), this.state.institution, this.state.start_date, this.state.end_date, this.state.type, this.state.status, offset)
      }

    }
  }


  render() {
    if (!this.props.accosts || !this.props.staffDetail || this.props.currentUserInstitutionsIsLoading) return <Spinner/>;

    return (
      <div>
        <Box>
        <PageHead>
					<h3>Список відгуків користувачів</h3>
				</PageHead>
          <Divider>
            <UniversalSearchWrapper onSubmit={this.onSubmitForm}>

            <UniversalSelectWrapper>
              <Label>Виберіть установу:</Label>
              <SelectWithSearchAsync
                searchable={true}
                isSearchable={true}
                value={this.state.institutionSelect}
                loadOptions={this.loadInstitutions}
                valueKey={'value'}
                labelkey={'label'}
                onChange={this.onChangeInstitutions}
                style={ this.selectStyle }
                placeholder="Почніть вводити для пошуку..."
                noResultsText="Немає результатів"
              />
            </UniversalSelectWrapper>


          <UniversalSelectWrapper>
            <Label>Виберіть лікаря:</Label>
            <SelectWithSearchAsync
              searchable={true}
              isSearchable={true}
              value={this.state.personalSelect}
              loadOptions={this.loadPersonal}
              valueKey={'value'}
              labelkey={'label'}
              onChange={this.onChangePersonal}
              style={ this.selectStyle }
              placeholder="Почніть вводити для пошуку..."
              noResultsText="Немає результатів"
            />
          </UniversalSelectWrapper>


          <UniversalDateWrapper>
              <UniversalDateTime>
                <Label>Початкова дата</Label>
                <DatePicker
                  locale="uk-UA"
                  selected={this.state.start_date}
                  dateFormat="DD-MM-YYYY"
                  onChange={this.onChangeStartDate}
                  onClickOutside={this.clickOutside}
                  ref="pickerStart"
                />
              </UniversalDateTime>
              <UniversalDateTime>
                <Label>Кінцева дата</Label>
                <DatePicker
                  locale="uk-UA"
                  selected={this.state.end_date}
                  dateFormat="DD-MM-YYYY"
                  onChange={this.onChangeEndDate}
                  onClickOutside={this.clickOutside}
                  ref="pickerEnd"
                />
              </UniversalDateTime>
            </UniversalDateWrapper>

              <UniversalSelectWrapper>
                <Label>Тип звернення:</Label>
                <Select value={this.state.type} onChange={this.changeType}>
                  <option defaultValue value="">Всі</option>
                  <option value="gratitude">Подяка</option>
                  <option value="complaint">Скарга</option>
                </Select>
              </UniversalSelectWrapper>

              <UniversalSelectWrapper>
                <Label>Cтатус:</Label>
                <Select value={this.state.status} onChange={this.changeStatus}>
                  <option defaultValue value="">Всі</option>
                  <option value="1">Підтверджено</option>
                  <option value="2">Відхилено</option>
                  <option value="0">На розгляді</option>
                </Select>
              </UniversalSelectWrapper>

              <ButtonDefault type="submit" value="Пошук" />
            </UniversalSearchWrapper>
          </Divider>

          {this.props.accosts.get('results').size > 0 ? (
            <div>
              {this.props.isLoading ? (
                <Spinner />
              ):(
                  <AccostsList accosts={this.props.accosts.get('results')} />
              )}
            </div>
          ):(
            <SearchFail>Відгуки відсутні</SearchFail>
          )}

          <Pagination counts={this.props.accosts.get('count')} path={`/administration/staff-reviews/`} matched={this.props.match.params.page} limits={10} />
        </Box>
      </div>

    )
  }
}

export default  withRouter(connect(mapStateToProps, mapDispatchToProps)(AdministrationReviews));



// WEBPACK FOOTER //
// ./src/administration/reviews/index.js